export const theme = {
  colors: {
    primary: '#00848C',
    gray: "#D0DBE1",
    red: "#EB5757",
    button: {
      primary: '#00848C',
      inactive: '#0C8AEE',
    },
    font: {
      black: '#333333',
      white: '#ffffff',
      error: "#FE446D"
    },
    black: '#000000',
    white: '#ffffff',
    greens: ['#F2F9F5', '#BFEDD5', '#4CAF7C'],
    background: {
      green: '#F2F9F5',
      light_green: '#F2F7F8'
    },
    header: '#4CAF7C',
  },
  fontSizes: {
    tiny: '10px',
    small: '12px',
    normal: '14px',
    large: '18px',
    xlarge: '20px',
  },
  fontWeights: {
    // NOTE: overwrite css-native `normal` and `bold`
    normal: 400,
    bold: 600,
  },
}

